



































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeaderUserMenu from '@/app/components/Common/Header/HeaderUserMenu.vue'
import Local from '@/app/module/local'
import { routerPath } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    HeaderUserMenu
  }
})
export default class Header extends Vue {
  private activeBtn: boolean = false
  private userType: string|null = ''
  private userName: string|null = ''
  private isAuth: boolean = false
  private isAdmin: boolean = false

  created () {
    if (Local.getAuthToken()) {
      this.isAuth = true
    }

    if (Local.getUserName()) {
      this.userName = Local.getUserName()
    } else {
      this.userName = '名無し'
    }

    if (Local.getUserType()) {
      switch (Local.getUserType()) {
        case '0':
          this.userType = '指定なし'
          break

        case '2':
          this.userType = '代表者'
          this.isAdmin = true
          break

        case '3':
          this.userType = '圃場管理者'
          break

        case '4':
          this.userType = '圃場作業者'
          break

        case '6':
          this.userType = '全圃場閲覧者'
          break

        default:
          break
      }
    }
  }

  private stringCut (data: string) {
    if (data !== '' && data !== undefined) {
      if (data.length > 15) {
        return data.substr(0, 14) + '…'
      } else {
        return data
      }
    }
  }

  private doLogout () {
    CommonClass.doSpLogout()
  }
}
